import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Contact from "../Contact/Contact.js";
import "./style.css";

import Stackoverflow from "../works/img/stackoverflow.jpg";


export default function DetailWork() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Add an empty dependency array to run the effect only once

  const navigate = useNavigate()

  const handleClick = () => {
    navigate("/")
  }
  return (
    <>
     <nav onClick={handleClick} className='singleWork'>
        <p>Back</p>
      </nav>
      <div className="untree_co-section untree_co-section-4 pb-0" id="portfolio-section">
          <div className="container">
            <div className="portfolio-single-wrap unslate_co--section" id="portfolio-single-section">
              <div className="portfolio-single-inner">
                <h2 className="heading-portfolio-single-h2  mt-5" style={{color:"#063dcc"}}>STACKOVERFLOW</h2>

                <div className="row justify-content-between mb-5">
                  <div className="col-12 mb-4">
                    <div className="owl-carousel single-slider">
                    </div>
                  </div>
                  <div className="col-12 my-5">
                    <div className="row">
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Project Date</h4>
                          <span className="detail-val" style={{color:"#063dcc"}}>Mar - May - 2023</span>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Role</h4>
                          <span className="detail-val">
                            <span style={{color:"#063dcc"}}>User</span>
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Code</h4>
                          <a style={{color:"#063dcc"}} className="detail-val" href='https://github.com/ASFER8384/Stackoverflow.git' target="_blank"  >Live Github</a>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Website</h4>
                          <span className="detail-val">
                            <a style={{color:"#063dcc"}} href="https://stackoverflowclone-f2k5.onrender.com/" target="_blank">Live Site</a>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <p style={{color:"#063dcc"}}>
                    Introducing CodeCollab, a vibrant community for programmers and developers. Get quick answers to your coding questions, share your expertise, and collaborate on complex technical challenges. Ask, answer, and earn reputation points while connecting with a global network of coding enthusiasts. Our intuitive platform offers a vast knowledge base and lively discussions, making it your go-to resource for all things programming. Join the conversation and elevate your coding skills. Start your journey on CodeCollab today!
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p style={{color:"#063dcc"}}>
                    CodeCollab is where programmers find solutions, build their reputations, and forge valuable connections. With a diverse user base, you'll experience an unparalleled exchange of ideas and knowledge. Whether you're a seasoned developer or just starting your coding journey, CodeCollab is the platform to propel your skills and expertise to new heights. Join us and be part of this dynamic and inclusive coding community. Explore, learn, and grow together with your fellow coders on CodeCollab.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    <Contact/>
    </>
  );
}
